import { useState, useEffect } from "react";

const Selector =  ({tabsData, clickHandler, active }) => {
  const [activeTabIndex, setActiveTabIndex] = useState(active);
  
  useEffect(() => {
    setActiveTabIndex(active)
  }, [active]);

  return <div className="flex grow gap-1 overflow-x-auto rounded-xl bg-slate-100 p-1">
    
    {tabsData.map((tab, idx) => <button
      type="button"
      key={idx}
      className={`min-h-[2.75rem] grow whitespace-nowrap rounded-lg px-4 py-2 text-center text-sm font-bold transition-all duration-200
        ${
          idx === activeTabIndex
          ? "bg-white text-cyan-800 shadow-sm"
          : "text-slate-500 hover:bg-white/70 hover:text-slate-700"
        }
      `}
      onClick={() => {
        clickHandler(idx);
        setActiveTabIndex(idx);
      }
    }>
      <div className="flex flex-col">
        <div>{tab}</div>
      </div>
    </button>)}
  </div>
}
export default Selector;
